
import { defineComponent, SetupContext, PropType, Events } from "vue";
import draggable from 'vuedraggable'
import MyListFolderListItem from "@/components/favorites/MyListFolderListItem.vue";
import { FolderInfo } from "@/types/favorites";
import NativeClient from "@/client/native-client";

const currentDisplayFolderList: Array<FolderInfo> = [];

export default defineComponent({
  name: "MyListFolderList",
  components: { MyListFolderListItem, draggable },
  props: {
    /** フォルダーリスト */
    folderList: {
      type: Array as PropType<FolderInfo[]>,
      default: () => []
    }
  },
  data: function() {
    // ここで定義しないと、編集用できない
    const currentDisplayFolderList: Array<FolderInfo> = [];
    for (const element of this.folderList) {
      const folderInfo = new FolderInfo();
      folderInfo.id = element.id;
      folderInfo.name = element.name;
      folderInfo.image = element.image;
      folderInfo.numberOfItems = element.numberOfItems;
      currentDisplayFolderList.push(folderInfo);
    }

    return {
      displayFolderList: currentDisplayFolderList,
      disabled: false
    };
  },
  methods: {
    dragEnd(event: any) {
      NativeClient.sendDebugLog("MyListFolderList dragEnd");
      if (event.newIndex != null) {
        if (event.oldIndex != null && event.oldIndex == event.newIndex) {
          NativeClient.sendDebugLog("MyListFolderList dragEnd ignore change new == old");
          return;
        }
        const index = event.newIndex;
        const tempArray: Array<FolderInfo> = this.displayFolderList;
        const folderId = tempArray[index].id;
        NativeClient.sendDebugLog("MyListFolderList dragEnd move id = " + folderId + ", index = " + index);
        this.$emit('move-folder', folderId, index + 1);
      }
    }
  },
  setup(props, context: SetupContext) {
    // フォルダー押下時にフォルダーidを通知する
    const selectFolder = (id: number, name: string) => {
      context.emit("on-click", id, name);
    };

    return {
      selectFolder
    };
  }
});
